'use strict';

angular.module('searchModule')

.controller('SearchResultsSolrController', ['$scope', '$sce', '$state', '$stateParams', 'historyCtxtService', function ($scope, $sce, $state, $stateParams, historyCtxtService) {

    // Show More Results
    $scope.showMoreResults = function (sourceType) {
        $scope.searchCtx.isLeftBarOpen = false;
        $scope.searchCtx.searchCtxt = null;
        $scope.searchCtx.searchSuggestions = false;
        $state.go('advancedSearch', { sourceType: sourceType.sourceType, q: $scope.searchCtx.q }, { location: 'replace', reload: true });
    };

    // Show All Results
    $scope.showAllResults = function () {
        $scope.searchCtx.isLeftBarOpen = false;
        $scope.searchCtx.searchCtxt = null;
        $scope.searchCtx.searchSuggestions = false;
        $state.go('advancedSearch', { q: $scope.searchCtx.q }, { location: 'replace', reload: true });
    };

    // Go To Advanced Search
    $scope.goToAdvancedSearch = function (entityName, name) {
        $scope.searchCtx.isLeftBarOpen = false;
        $scope.searchCtx.searchCtxt = null;
        $scope.searchCtx.searchSuggestions = false;
        $scope.searchCtx.q = name;

        $state.go('advancedSearch', {q: $scope.searchCtx.q }, { location: 'replace', reload: true });
    };
    
    // Go To Risk
    $scope.goToRisk = function (item) {
        $scope.searchCtx.searchSuggestions = false;
        $scope.searchCtx.isLeftBarOpen = false;
        historyCtxtService.goToState('riskEdit',
            { RiskID: item.RiskID },
            $state.current.name
        );
    };

    // Go To Control
    $scope.goToControl = function (item) {
        $scope.searchCtx.searchSuggestions = false;
        $scope.searchCtx.isLeftBarOpen = false;
        historyCtxtService.goToState('control',
          { ControlID: item.ControlID },
          $state.current.name
        );
    };

    // Go To Audit Mandate
    $scope.goToAuditMandate = function (item) {
        $scope.searchCtx.isLeftBarOpen = false;
        historyCtxtService.goToState('auditMandateEdit', {
            AuditMandateID: item.AuditMandateID
        },
            $state.current.name
        );
    };

    // Go To Committee
    $scope.goToCommittee = function (item) {
        $scope.searchCtx.searchSuggestions = false;
        $scope.searchCtx.isLeftBarOpen = false;
        historyCtxtService.goToState('committee',
          { CommitteeID: item.CommitteeID },
          $state.current.name
        );
    };

    // Go To Glossary Term
    $scope.goToGlossaryTerm = function (item) {
        $scope.searchCtx.searchSuggestions = false;
        $scope.searchCtx.isLeftBarOpen = false;
        historyCtxtService.goToState('glossaryTerm',
          { GlossaryTermID: item.LookupAttributeValueID },
          $state.current.name
        );
    };

    // Go To ActionPlan
    $scope.goToActionPlan = function (item) {
        $scope.searchCtx.searchSuggestions = false;
        $scope.searchCtx.isLeftBarOpen = false;
        historyCtxtService.goToState('recommendation.edit.actionPlan.edit', {
                RecommendationID: item.RecommendationID,
                ActionPlanID: item.ActionPlanID
            },
            $state.current.name
        );
    };

    // Go To Recommendation
    $scope.goToRecommendation = function (item) {
        $scope.searchCtx.searchSuggestions = false;
        $scope.searchCtx.isLeftBarOpen = false;
        historyCtxtService.goToState('recommendation.edit',
          { RecommendationID: item.RecommendationID },
          $state.current.name
        );
    };

    // Go To Observation
    $scope.goToObservation = function (item) {
        $scope.searchCtx.searchSuggestions = false;
        $scope.searchCtx.isLeftBarOpen = false;
        historyCtxtService.goToState('observation.edit',
          { ObservationID: item.ObservationID },
          $state.current.name
        );
    };

    // Go To Risk Event
    $scope.goToRiskEvent = function (item) {
        $scope.searchCtx.searchSuggestions = false;
        $scope.searchCtx.isLeftBarOpen = false;
        historyCtxtService.goToState('riskEventEdit',
            { RiskEventID: item.RiskEventID },
            $state.current.name
        );
    };

    // Go to Plan Initiative
    $scope.goToPlanInitiative = function (item) {
        $scope.searchCtx.searchSuggestions = false;
        $scope.searchCtx.isLeftBarOpen = false;
        historyCtxtService.goToState('initiative.edit',
            { InitiativeID: item.PlanInitiativeID },
            $state.current.name
        );
    };

    // Go to Procedure
    $scope.goToProcedure = function (item) {
        $scope.searchCtx.searchSuggestions = false;
        $scope.searchCtx.isLeftBarOpen = false;
        historyCtxtService.goToState('procedure.view', {
                ProcedureType: item.ProcedureTypeValue,
                ProcedureCode: item.ProcedureCodeFull
            },
            $state.current.name
        );
    };

    // Go to CalendarMeeting
    $scope.goToMeeting = function (meeting) {
        $scope.searchCtx.searchSuggestions = false;
        $scope.searchCtx.isLeftBarOpen = false;
        historyCtxtService.goToState('calendarMeetingEdit',
                                  { MeetingID: meeting.MeetingID },
                                  $state.current.name);
    };

    // Go To BIA Profile
    $scope.goToBIAProfile = function (item) {
        $scope.searchCtx.isLeftBarOpen = false;
        $scope.searchCtx.searchSuggestions = false;

        historyCtxtService.goToState('biaProfile.edit', {
            BIAProfileID: item.BIAProfileID
        },
            $state.current.name
        );
    };

}]);